import getPlaybackState from "selectors/chapter/getPlaybackState";
import { createSelector } from "reselect";
import getFlattenedQuestionList from "selectors/chapter/qa/getFlattenedQuestionList";
import findIndex from "lodash/findIndex";

export default createSelector(
  [getFlattenedQuestionList, getPlaybackState],
  (flattenedQuestionList, playbackState) => {
    const id = playbackState.currentQuestion
      ? playbackState.currentQuestion.id
      : 0;

    const index = findIndex(flattenedQuestionList, { id });
    return index;
  },
);
